import React from 'react';
import style from './style.scss';

class FairBanner extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="fair-banner">
        <img className='fair-banner-img' src={require('assets/images/fair/banner.png')}/>
        <img className='fair-banner-img-mobile' src={require('assets/images/fair/banner-mobile.jpg')}/>
        <div className='center'>
          <div className="fair-group">
            <p className="fair-time">Từ ngày 18/10 đến 20/12</p>
            <button className="fair-button">Đăng kí ngay</button>
          </div>
        </div>
      </div>
    );
  }
}

export default FairBanner;


// WEBPACK FOOTER //
// ./components/fair/sub-view/banner/FairBanner.jsx